<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/68Qy9D/tc-custom/9781781265703.jpg?1705038285558" alt="This image is the cover for the book Twenty to Knit: Knitted Baby Mitts, Twenty to Make"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Twenty to Knit: Knitted Baby Mitts, Twenty to Make
      </h1>
      <p class="bookDescription body article font2">
        <b>Knit adorable pairs of tiny mittens for the new baby in your life with this easy-to-use guide featuring twenty irresistible designs.</b><br/><br/>Knitwear designer Sian Brown shares twenty patterns in a range of colours and styles for boys and girls, from traditional stripes and cables to whimsical rabbits, frogs and ladybirds. Each design can be knitted in three different sizes suitable for 0-3, 3-6 and 6-12 month-old babies, with the option of including thumbs in the largest size. <br/><br/>The patterns use small amounts of either baby- or fingering-weight yarn, and knit up quickly and easily using the clear, step-by-step instructions and full-colour charts. Each project comes with a list of the yarns and needles required and a full-colour photograph of the finished mittens, providing everything you need to create these gorgeous handmade gifts for babies.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sian Brown
      </h2>
      
      <p class="authorDescription body article">Sian Brown has her own blog: sianbrown60@blogspot.co.uk and Facebook page: Sian Brown Knitwear Design. She is a freelance knitwear designer, and has designed handknits for commercial companies supplying high street stores, as well as for several knitting magazines, yarn companies and books. Her designs are sold also via Ravelry. Sian lives in East Sussex, UK.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      SEARCH PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f343a048